import { createFileRoute } from "@tanstack/react-router";
import { FaqPage } from "@/pages/legal/FaqPage";
import { localizedHead } from "@/lib/seo";

export const Route = createFileRoute("/faq")({
  head: () => {
    const lh = localizedHead({ path: "/faq", locale: "da" });
    return {
      meta: [
        { title: "FAQ — Farveladeland" },
        {
          name: "description",
          content:
            "Ofte stillede spørgsmål om Farveladeland: bestilling, fragt, fremvisning og vintage Murano-lamper.",
        },
        { property: "og:title", content: "FAQ — Farveladeland" },
        {
          property: "og:description",
          content:
            "Ofte stillede spørgsmål om bestilling, fragt og fremvisning hos Farveladeland.",
        },
        ...lh.meta,
      ],
      links: lh.links,
    };
  },
  component: FaqPage,
});
